import CalendarAction, {
    FETCH_INPAGE_CALENDAR_FULFILLED,
    FETCH_INPAGE_CALENDAR_PENDING,
    FETCH_INPAGE_CALENDAR_REJECTED,
    FETCH_CALENDAR_SIDEBAR_FULFILLED,
    FETCH_CALENDAR_SIDEBAR_PENDING,
    FETCH_CALENDAR_SIDEBAR_REJECTED,
    SET_CALENDAR_POPUP,
    FETCH_CALENDAR_PENDING,
    FETCH_CALENDAR_REJECTED,
    FETCH_CALENDAR_FULFILLED,
    CREATE_CALENDAR_EVENT_FULFILLED,
    SET_ACTIVE_CALENDAR,
    CREATE_CALENDAR_EVENT_REJECTED,
    CREATE_CALENDAR_EVENT_PENDING,
    CLEAR_ERROR_LIST,
    UPDATE_CALENDAR_EVENT_REJECTED,
    UPDATE_CALENDAR_EVENT_FULFILLED,
    UPDATE_CALENDAR_EVENT_PENDING,
    SET_CALENDAR_COLOR_PENDING,
    TOGGLE_CALENDAR_EVENT_DELETED_FULFILLED,
    FETCH_CALENDAR_EVENT_FULFILLED,
    FETCH_CALENDAR_EVENT_REJECTED,
    FETCH_CALENDAR_EVENT_PENDING,
    UPDATE_CALENDAR_EVENT_REALTIME,
    JOIN_CALENDAR_EVENT,
    LEAVE_CALENDAR_EVENT,
} from "./action-types";
import moment from "moment";
import { SpintrActionTypes } from "src/spintr/action-types";
import { AxiosResponse } from "axios";

export interface ICalendarPopupSettings {
    eventId?: number;
    isOpen: boolean;
    startDate?: Date;
    endDate?: Date;
    editMode?: boolean;
    event?: any;
    preSelectedCalendarId?: number;
    hideCalendarSelector?: boolean;
    errorList?: string[];
    isLoading?: boolean;
    onSave?: (event: any) => void;
    externalId?: string;
}

export interface ICalendarState {
    calendarPopup: ICalendarPopupSettings;
    hasMoreSidebarEvents: boolean;
    hasMoreInPageEvents: any[];
    isLoadingSidebar: boolean;
    isLoadingMoreSidebar: boolean;
    isLoadingInPage: any[];
    isLoadingMoreInPage: any[];
    sidebarEvents: Spintr.ICalendarEvent[];
    inPageCalendarEvents: Spintr.ICalendarEvent[];
    events: Spintr.ICalendarEvent[];
    event: any;
    activeCalendar: number;
    relativeExternalSkip: number;
    relativeExternalSkipInPage: any[];
    relativeSpintrSkip: number;
    relativeSpintrSkipInPage: any;
    lastFetchCalendarParams?: any;
}

const initialState: ICalendarState = {
    calendarPopup: {
        isOpen: false,
        errorList: [],
        isLoading: false,
    },
    hasMoreSidebarEvents: false,
    hasMoreInPageEvents: [],
    isLoadingSidebar: false,
    isLoadingMoreSidebar: false,
    isLoadingInPage: [],
    isLoadingMoreInPage: [],
    sidebarEvents: [],
    inPageCalendarEvents: [],
    events: [],
    event: { isLoading: true, event: {} },
    activeCalendar: 0,
    relativeExternalSkip: 0,
    relativeExternalSkipInPage: [],
    relativeSpintrSkip: 0,
    relativeSpintrSkipInPage: []
};

const setAttending = (id: number, userId, response: AxiosResponse, isAttending: boolean, state: ICalendarState) => {
    const events = [...state.events];

    const eventIndex = events.findIndex((e) => {
        return e.id === id;
    });

    if (eventIndex > -1) {
        if (isAttending) {
            // set status: 1
            const attendee = response.data.attendees.find((a) => {
                return a.id === userId;
            });

            const isInList = events[eventIndex].attendees.some((a) => {
                return a.id === userId;
            });

            if (isInList) {
                events[eventIndex].attendees = events[eventIndex].attendees.map((a) =>
                    a.id === userId ? { ...a, status: 1 } : a
                );
            } else {
                events[eventIndex].attendees.push(attendee);
            }

        } else {
            // set status: 2

            events[eventIndex].attendees = events[eventIndex].attendees.map((a) =>
                a.id === userId ? { ...a, status: 2 } : a
            );
        }
    }

    return events;
};

const setFavourite = (id: number, isFavourite: boolean, state: ICalendarState) => {
    if (state.event.event.id === id) {
        return {
            ...state.event.event,
            isFavourite,
        };
    }

    return state.event.event;
};

const setFollowing = (id: number, isFollowing: boolean, state: ICalendarState) => {
    if (state.event.event.id === id) {
        return {
            ...state.event.event,
            isFollowing,
        };
    }

    return state.event.event;
};

const calendarReducer = (state: ICalendarState = initialState, action: CalendarAction) => {
    switch (action.type) {
        case FETCH_INPAGE_CALENDAR_PENDING:
            const pShowMoreInPage = action.meta.params.relativeExternalSkip > 0 || action.meta.params.relativeSpintrSkip > 0;

            return {
                ...state,
                isLoadingMoreInPage: {
                    ...state.isLoadingMoreInPage,
                    [action.meta.params.calendarId]: pShowMoreInPage ? true : state.isLoadingMoreInPage[action.meta.params.calendarId],
                },
                isLoadingInPage: {
                    ...state.isLoadingInPage,
                    [action.meta.params.calendarId]: !pShowMoreInPage ? true : state.isLoadingInPage[action.meta.params.calendarId],
                },
            };

        case FETCH_INPAGE_CALENDAR_REJECTED:
            const rShowMoreInPage = action.meta.params.relativeExternalSkip  > 0 || action.meta.params.relativeSpintrSkip > 0;

            return {
                  ...state,
                  isLoadingMoreInPage: {
                    ...state.isLoadingMoreInPage,
                    [action.meta.params.calendarId]: rShowMoreInPage ? false : state.isLoadingMoreInPage[action.meta.params.calendarId],
                },
                isLoadingInPage: {
                    ...state.isLoadingInPage,
                    [action.meta.params.calendarId]: !rShowMoreInPage ? false : state.isLoadingInPage[action.meta.params.calendarId],
                },
            };

        case FETCH_INPAGE_CALENDAR_FULFILLED:
            const inPageEvents = action.payload.data.map((event) => {
                return {
                    ...event,
                    
                    presentingCalendarId: action.meta.params.calendarId,
                    end: new Date(event.end),
                    start: new Date(event.start),
                };
            });

            const fShowMoreInpage = action.meta.params.relativeExternalSkip > 0 || action.meta.params.relativeSpintrSkip > 0;

            return {
                ...state,
                hasMoreInPageEvents: {
                    ...state.hasMoreInPageEvents,
                    [action.meta.params.calendarId]: action.meta.params.take === action.payload.data.length,
                },
                isLoadingMoreInPage: {
                    ...state.isLoadingMoreInPage,
                    [action.meta.params.calendarId]: fShowMoreInpage ? false : state.isLoadingMoreInPage[action.meta.params.calendarId],
                },
                isLoadingInPage: {
                    ...state.isLoadingInPage,
                    [action.meta.params.calendarId]: !fShowMoreInpage ? false : state.isLoadingInPage[action.meta.params.calendarId],
                },
                events: fShowMoreInpage
                    ? [
                        ...state.events.filter(i => !inPageEvents.map(ie => ie.id).includes(i.id)),
                        ...inPageEvents
                    ].sort((a, b) => (a.start as Date).getTime() - (b.start as Date).getTime())
                    : [
                        ...state.events.filter(i => !inPageEvents.map(ie => ie.id).includes(i.id)),
                        ...inPageEvents
                    ].sort((a, b) => (a.start as Date).getTime() - (b.start as Date).getTime()),

                relativeExternalSkipInPage: {
                    ...state.relativeExternalSkipInPage,
                    [action.meta.params.calendarId]: Number.isInteger(state.relativeExternalSkipInPage[action.meta.params.calendarId])
                        ? state.relativeExternalSkipInPage[action.meta.params.calendarId] + Number(action.payload.headers["x-relative-external-skip"])
                        : Number(action.payload.headers["x-relative-external-skip"]),
                },

                relativeSpintrSkipInPage: {
                    ...state.relativeSpintrSkipInPage,
                    [action.meta.params.calendarId]: Number.isInteger(state.relativeSpintrSkipInPage[action.meta.params.calendarId])
                        ? state.relativeSpintrSkipInPage[action.meta.params.calendarId] + Number(action.payload.headers["x-relative-spintr-skip"])
                        : Number(action.payload.headers["x-relative-spintr-skip"]),
                },
            };
            
        case FETCH_CALENDAR_SIDEBAR_PENDING:
            return {
                ...state,
                isLoadingMoreSidebar: action.meta.params.relativeExternalSkip > 0 || action.meta.params.relativeSpintrSkip > 0
                    ? true
                    : state.isLoadingMoreSidebar,
                isLoadingSidebar: !(action.meta.params.relativeExternalSkip > 0 || action.meta.params.relativeSpintrSkip > 0)
                    ? true
                    : state.isLoadingSidebar,
            };

        case FETCH_CALENDAR_SIDEBAR_REJECTED:
            return {
                ...state,
                isLoadingMoreSidebar: action.meta.params.relativeExternalSkip > 0 || action.meta.params.relativeSpintrSkip > 0
                    ? false
                    : state.isLoadingMoreSidebar,
                isLoadingSidebar: !(action.meta.params.relativeExternalSkip > 0 || action.meta.params.relativeSpintrSkip > 0)
                    ? false
                    : state.isLoadingSidebar,
            };

        case FETCH_CALENDAR_SIDEBAR_FULFILLED:
            const nextState = {
                ...state,
                hasMoreSidebarEvents: action.meta.params.take === action.payload.data.length,
            };

            if (action.meta.params.relativeExternalSkip > 0 || action.meta.params.relativeSpintrSkip > 0) {
                nextState.isLoadingMoreSidebar = false;
            } else {
                nextState.isLoadingSidebar = false;
            }

            const events = action.payload.data.map((event) => {
                return {
                    ...event,

                    end: new Date(event.end),
                    start: new Date(event.start),
                };
            });

            if (action.meta.params.relativeExternalSkip > 0 || action.meta.params.relativeSpintrSkip > 0) {
                nextState.sidebarEvents = [...nextState.sidebarEvents, ...events];
            } else {
                nextState.sidebarEvents = events;
            }

            nextState.relativeExternalSkip = parseInt(action.payload.headers["x-relative-external-skip"], 10);
            nextState.relativeSpintrSkip = parseInt(action.payload.headers["x-relative-spintr-skip"], 10);
            
            return nextState;

        case FETCH_CALENDAR_FULFILLED:
            return {
                ...state,
                events: action.payload.data.map((event) => {
                    let end = new Date(event.end);

                    // Needed because of bug in react-big-calendar
                    if (end.getHours() === 0 &&
                        end.getMinutes() === 0 &&
                        end.getSeconds() === 0 &&
                        end.getMilliseconds() === 0) {
                        end = new Date(end.getTime() + 1);
                    }

                    return {
                        ...event,
                        start: new Date(event.start),
                        end
                    };
                }),
                lastFetchCalendarParams: action.payload.config && action.payload.config.params
                    ? action.payload.config.params
                    : state.lastFetchCalendarParams,
            };

        case FETCH_CALENDAR_EVENT_PENDING:
            return {
                ...state,
                event: {
                    ...state.event,
                    isLoading: true,
                },
            };

        case FETCH_CALENDAR_EVENT_REJECTED:
            return {
                ...state,
                event: {
                    ...state.event,
                    isLoading: false,
                },
            };

        case FETCH_CALENDAR_EVENT_FULFILLED:
            return {
                ...state,
                event: {
                    ...state.event,
                    isLoading: false,
                    event: {
                        ...action.payload.data,
                        start: new Date(action.payload.data.start),
                        end: new Date(action.payload.data.end),
                        registrationClose: action.payload.data.registrationClose
                            ? new Date(action.payload.data.registrationClose)
                            : null,
                        eventHasExpired: action.payload.data.end && new Date() > new Date(action.payload.data.end),
                        participants: action.payload.data.attendees
                            .concat(action.payload.data.invited, (action.payload.data as any).rejected),
                        isMultipleDays: !moment(action.payload.data.start).isSame(action.payload.data.end, "day"),
                    }
                },
            };

        case SET_CALENDAR_POPUP:
            return {
                ...state,
                calendarPopup: {
                    eventId: action.eventId,
                    isOpen: action.isOpen,
                    startDate: action.startDate,
                    endDate: action.endDate,
                    editMode: action.editMode,
                    event: action.event,
                    preSelectedCalendarId: action.preSelectedCalendarId,
                    hideCalendarSelector: action.hideCalendarSelection,
                    onSave: action.onSave,
                    externalId: action.externalId
                },
            }
            break;

        case SET_ACTIVE_CALENDAR:
            return {
                ...state,
                activeCalendar: action.id,
            };

        case SET_CALENDAR_COLOR_PENDING:
            return {
                ...state,
                events: state.events.map((event) => event.calendarId !== action.meta.id
                    ? event
                    : { ...event, color: "#" + action.meta.color }),
            };

        case CLEAR_ERROR_LIST:
            return {
                ...state,
                calendarPopup: {
                    ...state.calendarPopup,
                    errorList: initialState.calendarPopup.errorList,
                },
            };

        case CREATE_CALENDAR_EVENT_PENDING:
            return {
                ...state,
                calendarPopup: {
                    ...state.calendarPopup,
                    isLoading: true,
                },
            };

        case CREATE_CALENDAR_EVENT_REJECTED:
            return {
                ...state,
                calendarPopup: {
                    ...state.calendarPopup,
                    errorList: (action as any).payload.response.data.errorlist || ["TeknisktFel"],
                    isLoading: false,
                },
            };

        case CREATE_CALENDAR_EVENT_FULFILLED:
            if (state.activeCalendar !== 0 && state.activeCalendar !== action.payload.data.calendarId) {
                return {
                    ...state,
                    calendarPopup: {
                        ...state.calendarPopup,
                        isLoading: false,
                        isOpen: false,
                    },
                };
            }

            return {
                ...state,
                calendarPopup: {
                    ...state.calendarPopup,
                    isLoading: false,
                    isOpen: false,
                },
                events: [
                    ...state.events,
                    {
                        ...action.payload.data,
                        end: new Date(action.payload.data.end),
                        start: new Date(action.payload.data.start),
                    }
                ],
            };

        case TOGGLE_CALENDAR_EVENT_DELETED_FULFILLED:
            // TODO: Toggle?
            return {
                ...state,
                events: state.events.filter((event) =>
                    event.id !== action.meta.event.id &&
                    event.recurringParentId !== action.meta.event.id),
            };

        case UPDATE_CALENDAR_EVENT_PENDING:
            return {
                ...state,
                calendarPopup: {
                    ...state.calendarPopup,
                    isLoading: true,
                },
            };

        case UPDATE_CALENDAR_EVENT_REJECTED:
            return {
                ...state,
                calendarPopup: {
                    ...state.calendarPopup,
                    errorList: (action as any).payload.response.data.errorlist || ["TeknisktFel"],
                    isLoading: false,
                },
            };

        case UPDATE_CALENDAR_EVENT_FULFILLED:
            let newState = {
                ...state,
                calendarPopup: {
                    ...state.calendarPopup,
                    isLoading: false,
                    isOpen: false,
                },
            };

            var eventIdx = newState.events.findIndex(
                (event) =>
                    (!!event.id && event.id == action.payload.data.id) ||
                    (!!event.exchangeId && event.exchangeId == action.payload.data.exchangeId)
            );

            if (eventIdx > -1) {
                newState = {
                    ...newState,
                    events: newState.events.map((ev, idx) => idx === eventIdx
                        ? {
                            ...ev,
                            ...action.payload.data,
                        }
                        : ev),
                };
            }

            if (newState.event.event.id === action.payload.data.id) {
                newState = {
                    ...newState,
                    event: {
                        ...newState.event,
                        event: {
                            ...newState.event.event,
                            ...action.payload.data
                        },
                    },
                };
            }

            if (action.payload.data.isRecurring) {
                newState = {
                    ...newState,
                    events: newState.events.map((ev: any) => {
                        if (ev.recurringParentId !== action.payload.data.id) {
                            return ev;
                        }

                        return {
                            ...ev,
                            title: action.payload.data.title,
                            start: action.payload.data.start,
                            end: action.payload.data.end,
                        }
                    }),
                };
            }

            return newState;

        case UPDATE_CALENDAR_EVENT_REALTIME:
            const newEvent = action.meta.event;

            const eventSidebarIdx = state.sidebarEvents.findIndex(
                (sidebarEvent) => sidebarEvent.id === newEvent.id || sidebarEvent.exchangeId === newEvent.exchangeId
            );

            return {
                ...state,
                event: (newEvent.id === state.event.event.id || newEvent.exchangeId === state.event.event.exchangeId)
                    ? {
                        ...state.event,
                        event: {
                            ...state.event.event,
                            title: newEvent.title,
                            text: newEvent.description,
                            allDay: newEvent.allDay,
                            start: new Date(newEvent.start),
                            end: new Date(newEvent.end),
                            eventHasExpired: newEvent.end && new Date() > new Date(newEvent.start),
                        },
                    }
                    : state.event,
                sidebarEvents: eventSidebarIdx > -1
                    ? state.sidebarEvents.map((sidebarEvent, idx) => idx === eventSidebarIdx
                        ? {
                            ...sidebarEvent,
                            title: newEvent.title,
                            description: newEvent.description,
                            allDay: newEvent.allDay,
                            start: new Date(newEvent.start),
                            end: new Date(newEvent.end),
                        }
                        : sidebarEvent)
                    : state.sidebarEvents,                
            };

        case LEAVE_CALENDAR_EVENT:
            return {
                ...state,
                events: setAttending(action.meta.id, action.meta.userId, action.meta.response, false, state),
            };

        case JOIN_CALENDAR_EVENT:
            return {
                ...state,
                events: setAttending(action.meta.id, action.meta.userId, action.meta.response, true, state),
            };

        case SpintrActionTypes.AddToFavoritePending:
            return {
                ...state,
                event: {
                    ...state.event,
                    event: setFavourite(action.meta, true, state),
                },
            };

        case SpintrActionTypes.AddToFavoriteRejected:
            return {
                ...state,
                event: {
                    ...state.event,
                    event: setFavourite(action.meta, false, state),
                },
            };

        case SpintrActionTypes.RemoveFromFavoritesPending:
            return {
                ...state,
                event: {
                    ...state.event,
                    event: setFavourite(action.meta, false, state),
                },
            };
        case SpintrActionTypes.RemoveFromFavoritesRejected:
            return {
                ...state,
                event: {
                    ...state.event,
                    event: setFavourite(action.meta, true, state),
                },
            };

        case SpintrActionTypes.StartFollowingObjectPending:
            return {
                ...state,
                event: {
                    ...state.event,
                    event: setFollowing(action.meta, true, state),
                },
            };

        case SpintrActionTypes.StartFollowingObjectRejected:
            return {
                ...state,
                event: {
                    ...state.event,
                    event: setFollowing(action.meta, false, state),
                },
            };

        case SpintrActionTypes.StopFollowingObjectPending:
            return {
                ...state,
                event: {
                    ...state.event,
                    event: setFollowing(action.meta, false, state),
                },
            };

        case SpintrActionTypes.StopFollowingObjectRejected:
            return {
                ...state,
                event: {
                    ...state.event,
                    event: setFollowing(action.meta, true, state),
                },
            };

        default:
            return state;
    }
};

export default calendarReducer;
